import { defineLocale } from "../../registry";

const badges = defineLocale({
  ru: {
    "badges.status.draft": "Черновик",
    "badges.status.published": "Опубликован",
    "badges.status.archived": "В архиве",
    "badges.status.unknown": "Неизвестный статус",
    "badges.visibility.visible": "Visible",
    "badges.visibility.hidden": "Hidden",
    "badges.visibility.hiddenReason": "Hidden — {reason}",
    "badges.hiddenReason.not_published": "не опубликован",
    "badges.hiddenReason.available_from_pending":
      "окно доступности ещё не началось",
    "badges.hiddenReason.available_until_passed":
      "окно доступности закончилось",
    "badges.hiddenReason.deal_status_invalid":
      "статус сделки не допускает показ",
    "badges.hiddenReason.compliance_not_cleared":
      "проверка соответствия не пройдена",
    "badges.hiddenReason.rights_unknown": "права на материалы не подтверждены",
    "badges.hiddenReason.cover_missing": "нет обложки",
    "badges.hiddenReason.copy_en_missing": "нет английского текста",
    "badges.hiddenReason.unknown": "причина не распознана",
    "badges.priceWarning": "Price needs update",
    "badges.optionIssue.link_dead": "Ссылка не работает",
    "badges.optionIssue.link_unconfirmed": "Ссылка не подтверждена",
    "badges.optionIssue.host_not_allowed": "Хост не разрешён",
    "badges.optionIssue.partner_disabled": "Партнёр отключён",
    "badges.optionIssue.unknown": "Неизвестная причина опции",
  },
  en: {
    "badges.status.draft": "Draft",
    "badges.status.published": "Published",
    "badges.status.archived": "Archived",
    "badges.status.unknown": "Unknown status",
    "badges.visibility.visible": "Visible",
    "badges.visibility.hidden": "Hidden",
    "badges.visibility.hiddenReason": "Hidden — {reason}",
    "badges.hiddenReason.not_published": "not published",
    "badges.hiddenReason.available_from_pending":
      "availability window has not started",
    "badges.hiddenReason.available_until_passed":
      "availability window has ended",
    "badges.hiddenReason.deal_status_invalid":
      "deal status does not allow publishing",
    "badges.hiddenReason.compliance_not_cleared": "compliance is not cleared",
    "badges.hiddenReason.rights_unknown": "media rights are not confirmed",
    "badges.hiddenReason.cover_missing": "cover is missing",
    "badges.hiddenReason.copy_en_missing": "English copy is missing",
    "badges.hiddenReason.unknown": "unrecognized reason",
    "badges.priceWarning": "Price needs update",
    "badges.optionIssue.link_dead": "Link is dead",
    "badges.optionIssue.link_unconfirmed": "Link is not confirmed",
    "badges.optionIssue.host_not_allowed": "Host is not allowed",
    "badges.optionIssue.partner_disabled": "Partner is disabled",
    "badges.optionIssue.unknown": "Unrecognized option issue",
  },
});

export default badges;
